export default {"src":"/_next/static/media/logo.c8534d3e.svg","height":296,"width":1476};